import React from "react";
import "./MenuBtns.css"
import { Link, useParams } from "react-router-dom"

function MenuBtns() {
    const {id} = useParams()
    return (
        <nav className="menu game-menu" aria-label="Game menu">
                    <h5>Menu</h5>

                    {/* Returns to World Map */}
                    <Link className="menu-btn" to={"/continue/" + id}>
                        World Map
                    </Link>

                    {/* logs you out */}
                    <Link className="menu-btn" to="/">
                        Log Out!
                    </Link>
                </nav>
    )
}

export default MenuBtns;